import { useEffect } from 'react';

const SITE = 'The Sailing Doctor';
const BASE = 'https://thesailingdoctor.ru';

// Убирает HTML-теги и лишние пробелы, обрезает до n символов — для description из rich-text.
export function toDescription(html, n = 160) {
  if (!html) return '';
  const s = String(html).replace(/<[^>]+>/g, ' ').replace(/&[a-z]+;/gi, ' ').replace(/\s+/g, ' ').trim();
  return s.length > n ? s.slice(0, n - 1).trimEnd() + '…' : s;
}

function upsertMeta(attr, key, content) {
  if (content == null || content === '') return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', url);
}

// Абсолютный URL картинки (og:image и Schema.org требуют полный адрес)
function absUrl(u) {
  if (!u) return u;
  if (/^https?:\/\//.test(u)) return u;
  return BASE + (u.startsWith('/') ? u : '/' + u);
}

// Устанавливает уникальные title/description/canonical/OG для текущей страницы.
// Google и Яндекс исполняют JS при обходе, поэтому клиентская установка мета учитывается.
export function useSeo({ title, description, image } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — парусная школа`;
    document.title = fullTitle;

    // Канонический URL — всегда боевой (без префикса /preview), т.к. превью закрыто от индексации.
    const path = window.location.pathname.replace(/^\/preview/, '') || '/';
    const url = BASE + path;

    if (description) upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', fullTitle);
    if (description) upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    if (image) upsertMeta('property', 'og:image', absUrl(image));
    upsertCanonical(url);
  }, [title, description, image]);
}

// Вставляет структурированные данные Schema.org (JSON-LD) для текущей страницы.
// data — объект схемы или массив схем; null/undefined — убрать разметку страницы.
// Каждая страница управляет только своим скриптом (id=seo-jsonld), при уходе со
// страницы разметка удаляется — чтобы не «протекала» на другие маршруты.
export function useJsonLd(data) {
  useEffect(() => {
    const ID = 'seo-jsonld';
    let el = document.getElementById(ID);
    if (!data) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = ID;
      document.head.appendChild(el);
    }
    const payload = Array.isArray(data)
      ? data.map(d => ({ '@context': 'https://schema.org', ...d }))
      : { '@context': 'https://schema.org', ...data };
    el.textContent = JSON.stringify(payload);

    return () => { document.getElementById(ID)?.remove(); };
  }, [JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
}

export { absUrl, BASE, SITE };
